import { Component, Input } from '@angular/core';
import { ConsumerBusinessHandlerProvider } from '../../providers/consumer-business-handler';

@Component({
  selector: 'consumer-money-credit-list',
  templateUrl: 'consumer-money-credit-list.html'
})
export class ConsumerMoneyCreditListComponent {
	@Input('business') business;

	constructor(		
		public mainProvider: ConsumerBusinessHandlerProvider, 	
	) {
	}

	ngOnInit(){
		this.mainProvider.getUserPurchases({
			businessId: this.business.Id, 
			page: 1, 
			size: 20, 
		});
	}


}



// WEBPACK FOOTER //
// ./src/components/consumer-money-credit-list/consumer-money-credit-list.ts